import React from 'react';
import { Alert } from 'reactstrap';
import { connect } from 'react-redux'
class ErrorMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  render() {
    const { ErrorMessage } = this.props;
    let debug = null;
    if (ErrorMessage.debug) {
      debug = <pre className="alert-pre border bg-light p-2"><code>{ErrorMessage.debug}</code></pre>;
    }
    return (
      <Alert color="danger">
        <p className="mb-3">{ErrorMessage.message}</p>
        {debug}
      </Alert>
    );
  }
}
function mapStateToProps(state) {
  return {
    ErrorMessage: state.SidePanReducer.ErrorMessage || false
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  }
}
export default (connect(mapStateToProps, mapDispatchToProps)(ErrorMessage));